import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PostItem = styled.div`
  color: ${props => props.theme.colorMinor};
`;

const Member = ({ className, name, post }) => (
  <div className={className} data-test="team-member">
    <div>{name}</div>
    <div>
      {post.map((item, index) => (
        <PostItem key={index}>{item}</PostItem>
      ))}
    </div>
  </div>
);

Member.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  post: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Member;



// WEBPACK FOOTER //
// ./src/scenes/About/components/Team/components/Member.js